// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/mutation_other.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_EmbeddableCoreMessageListener_PaymentsPostPayment_Content(
  $amount: numeric!
  $reference_number: String
  $notes: String
  $location_id: uuid!
  $payment_account_id: numeric!
  $patient_id: uuid!
  $insured_id: numeric
  $payment_type_id: numeric!
  $auto_apply_to_unpaid_receivables: Boolean!
  $receivable_id: numeric
) {
  payments_post_payment_other(
    amount: $amount
    insured_id: $insured_id
    location_id: $location_id
    notes: $notes
    patient_id: $patient_id
    payment_account_id: $payment_account_id
    reference_number: $reference_number
    payment_type_id: $payment_type_id
    auto_apply_to_unpaid_receivables: $auto_apply_to_unpaid_receivables
    receivable_id: $receivable_id
  ) {
    payment_id
  }
}

`